import { MAIN_WRAPPER_CLASSNAME, SHOWN_CLASSNAME } from './constants';

export const toggleCategoriesMenu = (force: boolean) => {
    document.querySelector(`.${MAIN_WRAPPER_CLASSNAME}`)?.classList.toggle(SHOWN_CLASSNAME, force);
};
